export const simpleServices = [
  { slug: 'bladder-cancer', name: 'Bladder cancer', label: 'Bladder Cancer Urology' },
  { slug: 'bladder-stones', name: 'Bladder stones', label: 'Bladder Stones Urology' },
  { slug: 'fatigue', name: 'Fatigue', label: 'Fatigue Urology' },
  { slug: 'fecal-incontinence', name: 'Fecal incontinence', label: 'Fecal Incontinence Urology' },
  { slug: 'hypogonadism', name: 'Hypogonadism', label: 'Hypogonadism Urology' },
  { slug: 'interstim', name: 'Interstim', label: 'InterStim Urology' },
  { slug: 'kidney-stones', name: 'Kidney stones', label: 'Kidney Stones Urology' },
  { slug: 'low-libido', name: 'Low libido', label: 'Low Libido Urology' },
  { slug: 'oab', name: 'OAB', label: 'OAB Urology' },
  { slug: 'urolift', name: 'UroLift', label: 'UroLift' },
  { slug: 'testopel', name: 'Testopel', label: 'Testopel Urology' },
  { slug: 'testosterone', name: 'Testosterone', label: 'Testosterone Urology' },
  { slug: 'testosterone-pellets', name: 'Testosterone pellets', label: 'Testosterone Pellets Urology' },
  { slug: 'urge-incontinence', name: 'Urge incontinence', label: 'Urge Incontinence Urology' },
  { slug: 'urinary-frequency', name: 'Urinary frequency', label: 'Urinary Frequency Urology' },
  { slug: 'urinary-retention', name: 'Urinary retention', label: 'Urinary Retention Urology' },
  { slug: 'urinary-urgency', name: 'Urinary urgency', label: 'Urinary Urgency Urology' },
];
